// extracted by mini-css-extract-plugin
export default {"root":"DTVLwvVEbDBl3BoOJWAK","disabled":"fsv5iJaiKDrhqM4Vf639"};